<template>
  <div id="account-form">
    <el-form ref="accountForm" :model="accountForm" :rules="rules" label-width="120px" style="width:400px">
      <el-form-item label="登录名称" prop="loginName">
        <el-input v-model="accountForm.loginName"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="accountForm.password" type="password" :disabled="!changePassword"></el-input>
        <el-button @click="changePasswordFun"
                   type="text"
                   size="small">
          {{changePassword ?"保存":"修改"}}
        </el-button>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="accountForm.actualName"></el-input>
      </el-form-item>
      <el-form-item label="头像">
            <el-upload
              ref="upload"
              action="/api/sysConfig/upload"
              class="icon-uploader"
              :on-success="uploadHeadPicSuccess"
              :auto-upload="true"
              :show-file-list="false"
            >
              <img
                v-if="accountForm.headPic"
                :src="accountForm.headPic"
                class="icon-img"
              />
              <i v-else class="el-icon-plus icon-uploader-icon"></i>
              <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url" alt=""
              >
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview" >
                  <i class="icon-uploader-icon el-icon-edit">修改</i>
                </span>
              </span>
            </div>
            </el-upload>
      </el-form-item>
      <el-form-item label="所属部门" prop="deptId">
        <el-select style="width: 100%" v-model="accountForm.deptId" placeholder="请选择" disabled>
          <el-option
            v-for="item in deptList"
            :key="item.id"
            :label="item.deptName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电子邮箱" >
        <el-input v-model="accountForm.email"></el-input>
      </el-form-item>
      <el-form-item label="手机号" >
        <el-input v-model="accountForm.phone"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import utils from "../utils/utils"
  export default {
    name: "my-account",
    data(){
      return{
        accountForm:{
          id:null,
          loginName:"",
          password:"123456",
          actualName:"",
          deptId:null,
          email:"",
          phone:"",
          roleId:null
        },
        deptList:[],
        headPicImg:"",
        rules:{
          loginName:[
            {required: true, message: '请输入登录名称', trigger: 'blur'},
            {pattern: /^[a-zA-Z0-9]{4,12}$/, message: '请输入4-12为数字或者字母组合', trigger: ['blur', 'change']}
          ],
          password:[
            {required: true, message: '请输入密码', trigger: 'blur'},
            {pattern: /^[a-zA-Z0-9]{6,12}$/, message: '请输入6-12为数字或者字母组合', trigger: ['blur', 'change']}],
          actualName:[{required: true, message: '请输入姓名', trigger: 'blur'},{ min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur" }],
          companyId:[{required: true, message: '请选择所属单位', trigger: 'change'}],
          email:[
            {required: true, message: '请输入电子邮箱', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
          ],
          phone:[
            {required: true, message: '请输入手机号码', trigger: 'blur'},
            {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
          ]
        },
        changePassword:false,
      }
    },
    created(){
      this.getUserInfo()
      this.getDeptAll()

    },
    methods:{
      getUserInfo(){
        utils.axiosMethods({
          method: "GET",
          url: "/api/accountManage/getAccountBById",
          callback:(res => {
            this.accountForm = res.data.obj
            this.accountForm.password = "123456"
          })
        })
      },
      getDeptAll(){
        utils.axiosMethods({
          method: "GET",
          url: "/api/accountManage/queryDeptBAll",
          callback:(res => {
            this.deptList = res.data.list;
          })
        })
      },
    uploadHeadPicSuccess(response, file, fileList) {
      this.accountForm.headPic = response;
    },
      changePasswordFun(){
        this.$refs.accountForm.validateField('password',(message => {
          if(!message){
            this.changePassword = !this.changePassword;
            if(!this.changePassword){
              utils.axiosMethods({
                method: "POST",
                url:"/api/accountManage/changePassword",
                data:{
                  id:this.accountForm.id,
                  password:this.accountForm.password
                },
                callback:(res => {
                  this.$message.success("密码修改成功");
                  this.getData()
                })
              })
            }
          }
        }))
      },
      onSubmit(){
        //验证表单
        this.$refs["accountForm"].validate((valid) => {
          if(valid){
            let formData = {
              id:this.accountForm.id,
              loginName:this.accountForm.loginName,
              actualName:this.accountForm.actualName,
              email:this.accountForm.email,
              phone:this.accountForm.phone,
              roleId:this.accountForm.roleId,
              headPic:this.accountForm.headPic
            }
            utils.axiosMethods({
              method: "POST",
              url: "/api/accountManage/updateAccountB",
              data:formData,
              callback:(res => {
                if(res.data.code == 0){
                  this.$message.success("修改成功");
                }else{
                  this.$message.error(res.data.msg)
                }
              })
            })
          }
        })
      },
    }
  }
</script>

<style  lang="less">
#account-form{
  .icon-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    line-height: 0;
    overflow: hidden;
  }
  .icon-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .icon-uploader img{
    width: 120px;
    height: 120px;
    line-height: 0;
  }
  .icon-uploader-icon {
    color: #8c939d;
    text-align: center;
    width: 120px;
    height: 120px;
    line-height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myAccount.vue